/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import {
  bus
} from '../../main';
export default {
  name: 'author-assign-course',
  components: {},
  props: [],
  data() {
    return {
      showTab: 'personal',
      userData: {},
      countryList: [],
      removeAuthorCourseId:'',
      userCourseList:'',
      authorID:'',
      removeAuthorCourseId:''
    }
  },
  computed: {
    ...mapGetters([
      'getlastestCoursesState',
      'getAuthorDetailsByIDGetter'

    ]),
    getUserCourseList() {
      return this.userCourseList = this.$store.getters.getlastestCoursesState.data
    },
    getUserDetailsList() {
      return this.userData = this.$store.getters.getAuthorDetailsByIDGetter.data
    },
  },
  mounted() {
    this.authorID = this.$route.params.authorId
    this.getUserCourseList
    this.getUserDetailsList
  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getAuthorDetailsByIDFun', {
        id: this.$route.params.authorId
        })
    },
    getCourseListAgain() {
      this.$store.dispatch('getcourselist')
    },
    AssignedCourseToAuthor(courseid){
      let data = {
        course:courseid,
        user:this.$route.params.authorId
      }
      this.$store.dispatch('assingCourseToAuthorFun',  data).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    },
    removAuthorAssignedCourseModal(id) {
      $('#removAuthorAssignedCourseModal').modal();
      this.removeAuthorCourseId = id
    },
    removAuthorAssignedCourseConfirmationagain(){
      this.$store.dispatch('removeAssignedCourseAuthorFun', {
        data :{
          CourseId:this.removeAuthorCourseId,
          AuthorId:this.$route.params.authorId
        }
      }).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.getUserCourseList;
    this.getUserDetailsList
  },
  watch: {
    getUserCourseList() {
      return this.$store.getters.getlastestCoursesState.data
    },
    getUserDetailsList() {
      return this.$store.getters.getAuthorDetailsByIDGetter.data
    }
  }
}